import {callsApi, coachingApi} from 'sources/api';
import LiveCoachingCall from 'records/LiveCoachingCall';
import {List} from 'immutable';
import cancelIfSending from 'sources/cancelIfSending';
import CoachingReview from 'records/CoachingReview';

export default cancelIfSending({
  createEmpty(callerId) {
    return callsApi.post('/metadata-only', {callerId}).then(res => {
      return new LiveCoachingCall({id: res.data.callId, callerId});
    });
  },

  update(call) {
    const {dateTime, ...rest} = call.toJS();

    return callsApi.put(`/metadata-only/${call.id}`, {
      ...rest,
      dateTime: !dateTime ? undefined : dateTime.toISOString(true),
    });
  },

  searchAccounts(prefix) {
    return callsApi.post('/metadata-autocomplete/ACCOUNT', {prefix}).then(response => {
      return List(response.data);
    });
  },

  searchContacts(prefix, choices) {
    return callsApi.post('/metadata-autocomplete/CONTACT', {prefix, choices}).then(response => {
      return List(response.data);
    });
  },

  searchOpportunities(prefix, choices) {
    return callsApi.post('/metadata-autocomplete/OPPORTUNITY', {prefix, choices}).then(response => {
      return List(response.data);
    });
  },

  directions(callerId) {
    return callsApi.get(`/metadata-autocomplete/direction?callerId=${callerId}`).then(response => {
      return List(response.data.options);
    });
  },

  scoresBySkill(callId) {
    return callsApi.get(`/scorecards/skill-scores?callId=${callId}`).then(response => {
      return List(response.data);
    });
  },

  delete(callId) {
    return callsApi.delete(`/metadata-only/${callId}`);
  },

  finishLivecoachingReview(review, callId, comment, callRecordingLink) {
    return coachingApi.put(`/reviews/${review.id}/finish-livecoaching?call_id=${callId}`, {
      review,
      comment,
      callRecordingLink,
    });
  },

  retrieveForCall(callId) {
    return coachingApi
      .get(`/reviews/livecoaching/review_for?call_id=${callId}`)
      .then(r => new CoachingReview(r.data))
      .catch(error => {
        if (error && error.response && error.response.status === 404) {
          // This isn't a live coaching call, or there's no review.
          return;
        }
        // Something went wrong.
        throw error;
      });
  },
});
